import React, { useEffect, useState } from 'react';
import { compose } from 'ramda';
import connect from 'react-redux/es/connect/connect';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from '../style';
import Button from '@synergycms_core/components/generic/Button';
import RichText from '@synergycms_core/components/generic/RichText';
import Image from '@synergycms_core/components/generic/Image';

import actions from '../../../../../store/actions';
import { getLoyaltyAvailDiscountPercent } from '../../../../../store/avail/availUtils';

export const LoyaltyInfo = ({theme, theme: { styles: { classes } }, infoUser, user, refresh, discount, customerForm }) => {

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true)
    user().then(() => {
        setIsLoading(false)
      }).catch(error => {
        console.error('Error al cargar el usuario', error)
        setIsLoading(false)
      })
  }, [user])

  const logout = () => {
    return refresh()
      .then(() => {
        window.document.body.scrollTop = window.document.documentElement.scrollTop = 0;
      });
  };

  return (
    <>      
      <div className={[classes.info, classes.loginado, theme.width < 801 && classes.column].join(' ')}>
        {!customerForm &&        
          <div className={[classes.starLogo,customerForm ? classes.customerFormLogo : '',].join(' ')}>
            <Image svg={'memberOnlyBlue'}/>
          </div>        
        }
        {infoUser?.get("name") &&
          <>
             <div className={classes.textInfo}>
              <RichText
                dangerouslySetInnerHTML={true}
                withVars={{ NOMBREUSUARIO: infoUser?.get("name") ? infoUser.get("name") + ' ' + infoUser.get("surname") : '' }}
                text={'_%hola fidelizacion%_'}
                translate={true}
                innerStyle={classes.titleInfo} />
              <RichText
                text={'_%ventajas fidelizacion%_'}
                ucFirst={true}
                translate={true} />
            </div>
            <div className={classes.section}>
              <div className={classes.flex}>
                <div>
                  <RichText text={'_%numero fidelizacion%_'} translate={true} />
                </div>
                <b>
                  <RichText text={infoUser.get("user_id")} />
                </b>
              </div>
              <div className={[classes.flex, classes.withBorder].join(' ')}>
                <div>
                  <RichText text={'_%nivel fidelizacion%_'} translate={true} />
                </div>
                <b>
                  <RichText text={infoUser?.getIn(["tier", "current"],"-")} />
                </b>
              </div>
              <div className={classes.flex}>
                <div>
                  <RichText text={'_%descuento fidelizacion%_'} translate={true} />
                </div>
                <b>
                {discount && <RichText text={(discount ?? '-') + '%'} />}
                </b>
              </div>
            </div>
          </>
        }
        <div className={classes.textCenter}>
          <Button onClick={logout} disabled={isLoading} richText={{ text: '_%logout fidelizacion%_', translate: true, ucFirst: true }} innerStyle={[classes.buttonLogin, 'toggleSecondButton']} />
        </div>
      </div>
    </>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    refresh: () => {
      return dispatch(actions.customer.loyalty.logout());
    },
    user: () => {
      return dispatch(actions.customer.loyalty.getUser());
    }
  };
};

const mapStateToProps = (store) =>{
  
  const discount = getLoyaltyAvailDiscountPercent(store)
  return {
    discount : discount,
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withThemeJSS({ styleFile }), withContent('i18n'))(LoyaltyInfo);
